import { 
  zlbCostControlBdFeeItemCategoryListGet,
  zlbCostControlBdFeeItemSaveCategoryPost,
  zlbCostControlBdFeeItemFeeItemPagePost,
  zlbCostControlBdFeeItemSaveFeeItemPost,
  zlbCostControlBdFeeItemSaveFeeItemFieldPost,
  zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGet,
  zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGet,
  zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePost,
  zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePost,
  zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGet,
  zlbCostControlBdFeeItemChangeFeeItemStatusPost,
} from '@/api/zlbCostControl';
  
export default {
  namespace: 'FeeItemListManage',
  state: {},
  effects: {
    // 获取费用项分类列表
    * getFeeItemCategoryList ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemCategoryListGet, payload);
      return res;
    },
  
    // 获取费用项分类详情
    * getFeeItemCategoryDetail ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemCategoryDetailFeeItemCategoryCodeGet, payload);
      return res;
    },
    // 费用项分类保存
    * saveFeeItemCategory ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemSaveCategoryPost, payload);
      return res;
    },
    // 删除费用项分类
    * deleteFeeItemCategory ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemDeleteCategoryFeeItemCategoryCodePost, payload);
      return res;
    },
    // 费用项列表查询
    * getFeeItemList ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemFeeItemPagePost, payload);
      return res;
    },
    // 费用项详情
    * getFeeItemDetail ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemFeeItemDetailFeeItemCodeGet, payload);
      return res;
    },
    // 费用项字段配置详情
    * getFeeItemFieldDetail ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemFeeItemFieldFeeItemCodeGet, payload);
      return res;
    },
    // 保存费用项
    * saveFeeItem ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemSaveFeeItemPost, payload);
      return res;
    },
    // 保存费用项字段
    * saveFeeItemField ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemSaveFeeItemFieldPost, payload);
      return res;
    },

    // 删除费用项
    * deleteFeeItem ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemDeleteFeeItemFeeItemCodePost, payload);
      return res;
    },
    // 费用项启用、停用
    * changeFeeItemStatus ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemChangeFeeItemStatusPost , payload);
      return res;
    },
  },
     
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
  